import { Stack, Typography } from '@bymason-private/legacy-pattern-components';
import { getDataSize } from '@bymason/utils';

interface CardInfoProps {
  caption: string;
  leftIcon?: JSX.Element;
  value: number;
}

export default function CardInfo({ caption, leftIcon, value }: CardInfoProps) {
  const [numValue, numUnit] = getDataSize(value, 2);

  return (
    <Stack alignItems='center'>
      <Stack alignItems='center' direction='row'>
        {leftIcon && leftIcon}
        <Stack alignItems='baseline' direction='row' spacing={0.25}>
          <Typography variant='body1'>{numValue}</Typography>
          <Typography variant='body2' fontSize='0.75em'>
            {numUnit}
          </Typography>
        </Stack>
      </Stack>
      <Typography variant='body1' fontWeight='normal' fontSize='0.75em' sx={{ opacity: 0.6 }}>
        {caption}
      </Typography>
    </Stack>
  );
}
